import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import Select from 'components/global/CUK/AsyncSelect/Select';
import { OptionMultiCount } from 'components/global/CUK/AsyncSelect/components/Option';
import { useSites } from 'store'

import { OPERATION_COUNT_SYNC } from '../../operations-gql/queries';

const SynchronizeSelect = ({ onChange, values =[] }) => {
  const { t } = useTranslation();
  const [{ selected: sitesSelected }] = useSites()
  const sfIds = useMemo(
    () => (sitesSelected ? sitesSelected.map(({ sf_id }) => sf_id) : []),
    [sitesSelected],
  )
  const { data } = useQuery(OPERATION_COUNT_SYNC, {
    variables: {
      site_ids: sfIds
    }
  });
  const choices = [
    {
      label: t('auth.account_sync.sync'),
      value: 'sync',
      id: 1,
    },
    {
      label: t('auth.account_sync.not_sync'),
      value: 'not_sync',
      id: 2,
    },
  ];
  return (
    <Select
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      options={choices}
      mainField="label"
      placeholder={t('auth.admin.select_placeholder')}
      onChange={(values) => {
        onChange(values.map(({ value }) => value))
      }}
      components={{
        Option: (props) => {
          const count = useMemo(() => {
            return data
              ? data.values.find((state) => state.key === props.data.value)
                ?.count
              : 0;
          }, [data]);
          return (
            <OptionMultiCount {...props} value={props.data} count={count} />
          );
        }
      }}
      value={choices.filter(
        (choice) => values.findIndex((value) => choice.value === value) > -1,
      )}
    />
  );
};

export default SynchronizeSelect
